import React, { type ReactNode } from 'react'

import useOrganizationOwner from 'hooks/data/useOrganizationOwner'

type Props = {
	children: ReactNode
}
export default function OrganizationOwnerWrapper({ children }: Props): React.ReactNode {
	const ownerStatus = useOrganizationOwner()
	return ownerStatus === 'owner' ? children : <></>
}
